import { cx } from '@linaria/atomic';
import { PolymorphicComponentPropWithoutRef } from '../../../type-utils';
import { PrimaryButton, SecondaryButton } from '../../buttons';
import { ClickHandler, withClose } from '../atoms/helpers';
import { useModalContext } from '../provider';
import { trayActions } from './tray.styles';

type ComponentProps = {
  disabledPrimary?: boolean;
  onPrimaryClick?: ClickHandler;
  primaryLabel?: string;
  disabledSecondary?: boolean;
  onSecondaryClick?: ClickHandler;
  secondaryLabel?: string;
  primaryTrackingId?: string;
  secondaryTrackingId?: string;
};

type TrayActionsProps<T extends React.ElementType> = PolymorphicComponentPropWithoutRef<T, ComponentProps>;

export const TrayActions = <T extends React.ElementType = 'section'>({
  as,
  disabledPrimary = false,
  onPrimaryClick,
  primaryLabel,
  primaryTrackingId,
  disabledSecondary = false,
  onSecondaryClick,
  secondaryLabel,
  secondaryTrackingId,
  className,
  ...rest
}: TrayActionsProps<T>) => {
  const Component = as || 'section';
  const { onClose } = useModalContext();

  return (
    <Component className={cx(trayActions, className)} {...rest}>
      {onSecondaryClick && (
        <SecondaryButton
          className='tray-secondary-button'
          trackingId={secondaryTrackingId}
          disabled={disabledSecondary}
          onClick={withClose(onClose, onSecondaryClick)}
          size='large'
        >
          {secondaryLabel || 'Cancel'}
        </SecondaryButton>
      )}
      <PrimaryButton
        className='tray-primary-button'
        trackingId={primaryTrackingId}
        disabled={disabledPrimary}
        onClick={withClose(onClose, onPrimaryClick)}
        size='large'
      >
        {primaryLabel || 'Ok'}
      </PrimaryButton>
    </Component>
  );
};
